// Armazenamento do estado de autenticação (SEF-70).
//
// Decisão de storage (MVP, alinhada ao plano da SEF-55 — refresh token opaco
// entregue no body, SPA single-instance): tokens + dados do usuário ficam em
// Web Storage. "Lembrar-me" marcado → localStorage (persiste entre sessões do
// navegador); desmarcado → sessionStorage (expira ao fechar a aba). Cookie
// httpOnly fica como melhoria pós-MVP (ver frontend/todo.md). Pendente de
// ratificação do Tech Lead — não bloqueia o fluxo real.

const CHAVE = 'sefira.auth';

// Lê o estado salvo, procurando primeiro em localStorage (lembrar-me) e
// depois em sessionStorage.
export function lerAuth() {
  const bruto =
    localStorage.getItem(CHAVE) || sessionStorage.getItem(CHAVE);
  if (!bruto) return null;
  try {
    return JSON.parse(bruto);
  } catch {
    return null;
  }
}

// Persiste o estado completo logo após o login. `lembrar` escolhe o storage.
export function salvarAuth({ accessToken, refreshToken, usuario, lembrar }) {
  limparAuth();
  const destino = lembrar ? localStorage : sessionStorage;
  destino.setItem(
    CHAVE,
    JSON.stringify({ accessToken, refreshToken, usuario, lembrar }),
  );
}

// Atualiza apenas os tokens (após /refresh), preservando o storage escolhido
// no login.
export function atualizarTokens({ accessToken, refreshToken }) {
  const atual = lerAuth();
  if (!atual) return;
  const destino = atual.lembrar ? localStorage : sessionStorage;
  destino.setItem(
    CHAVE,
    JSON.stringify({ ...atual, accessToken, refreshToken }),
  );
}

// Atualiza apenas os dados do usuário (após editar o perfil), preservando
// tokens e o storage escolhido no login.
export function atualizarUsuario(usuario) {
  const atual = lerAuth();
  if (!atual) return;
  const destino = atual.lembrar ? localStorage : sessionStorage;
  destino.setItem(CHAVE, JSON.stringify({ ...atual, usuario }));
}

export function limparAuth() {
  localStorage.removeItem(CHAVE);
  sessionStorage.removeItem(CHAVE);
}

export function getAccessToken() {
  return lerAuth()?.accessToken || null;
}

export function getRefreshToken() {
  return lerAuth()?.refreshToken || null;
}

export function getUsuario() {
  return lerAuth()?.usuario || null;
}
